import { render, staticRenderFns } from "./AggregatorInterfaceField.vue?vue&type=template&id=3fb7f97a&scoped=true"
import script from "./AggregatorInterfaceField.vue?vue&type=script&lang=js"
export * from "./AggregatorInterfaceField.vue?vue&type=script&lang=js"
import style0 from "./AggregatorInterfaceField.vue?vue&type=style&index=0&id=3fb7f97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb7f97a",
  null
  
)

export default component.exports